var img = "data:image/svg+xml,%3csvg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='12' y='12' width='14' height='14' rx='1' fill='currentColor'/%3e%3c/svg%3e";
  export default img;